import { render, staticRenderFns } from "./AdsVertical.vue?vue&type=template&id=4e265a93&scoped=true&"
import script from "./AdsVertical.vue?vue&type=script&lang=js&"
export * from "./AdsVertical.vue?vue&type=script&lang=js&"
import style0 from "./AdsVertical.vue?vue&type=style&index=0&id=4e265a93&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e265a93",
  null
  
)

export default component.exports